module.exports = __webpack_public_path__ + "static/media/1.041dbfc8.jpg";